import { render, staticRenderFns } from "./Recipet.vue?vue&type=template&id=e56643dc&scoped=true"
import script from "./Recipet.vue?vue&type=script&lang=js"
export * from "./Recipet.vue?vue&type=script&lang=js"
import style0 from "./Recipet.vue?vue&type=style&index=0&id=e56643dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56643dc",
  null
  
)

export default component.exports